import React from 'react';
import cn from 'classnames';
import { injectIntl } from 'react-intl';

import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';

import './price-range.field.scss';

const STEP = 10;

const PriceRangeField = ({ field: {name, value}, form: {setFieldValue}, intl, className, ...props}) => {

	const onChangeMinimum = (v) => {
		let minimum = parseInt(v) || '';
		let maximum = value.max;
		setFieldValue(name, { min: minimum, max: maximum });
	};

	const onBlurMinimum = (v) => {
		let minimum = parseInt(v) || props.minPrice;
		let maximum = value.max;
		if(minimum > props.maxPrice){
			minimum = props.maxPrice;
		}
		if(minimum < props.minPrice){
			minimum = props.minPrice;
		}
		if(minimum > maximum){
			maximum = minimum;
		}
		setFieldValue(name, { min: minimum, max: maximum });
	};

	const onChangeMaximum = (v) => {
		let minimum = value.min;
		let maximum = parseInt(v) || '';
		setFieldValue(name, { min: minimum, max: maximum });
	};

	const onBlurMaximum = (v) => {
		let minimum = value.min;
		let maximum = parseInt(v) || props.maxPrice;
		if(maximum < props.minPrice){
			maximum = props.minPrice;
		}
		if(maximum > props.maxPrice){
			maximum = props.maxPrice;
		}
		if(minimum > maximum){
			minimum = maximum;
		}
		setFieldValue(name, { min: minimum, max: maximum });
	};

	return (
		<div {...props} className={cn('price', className)}>
			<InputRange
				aria-controls=""
				aria-labelledby=""
				step={STEP}
				formatLabel={value => `${value} €`}
				minValue={props.minPrice}
				maxValue={props.maxPrice}
				value={value}
				onChange={price => setFieldValue(name, {
					min: price.max < props.minPrice ? props.minPrice : price.min,
					max: price.max > props.maxPrice ? props.maxPrice : price.max,
				})
				}
			/>
			<div className="inputbox-range">
				<div className="input-container">
					<div className="icon">€</div>
					<input
						className="input-field"
						type="number"
						step={STEP}
						min={props.minPrice}
						max={props.maxPrice}
						value={value.min}
						onChange={price => onChangeMinimum(price.target.value)}
						onBlur={price => onBlurMinimum(price.target.value)}
					/>
				</div>

				<div className="hiffen">-</div>

				<div className="input-container">
					<div className="icon">€</div>
					<input
						type="number"
						step={STEP}
						min={value.min + STEP}
						value={value.max}
						onChange={price => onChangeMaximum(price.target.value)}
						onBlur={price => onBlurMaximum(price.target.value)}
					/>
				</div>

			</div>
		</div>
	);
};


export default injectIntl(PriceRangeField);
